import type { RouteRecordRaw } from 'vue-router'

export const mselDoctorRoutes: RouteRecordRaw[] = [
  {
    path: '/scenarios',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: {
      requiresAuth: true,
      module: 'msel-doctor',
      moduleDisplayName: 'MSEL Doctor',
    },
    children: [
      {
        path: '',
        name: 'scenarios',
        component: () => import('@/modules/msel-doctor/views/ScenariosView.vue'),
      },
      {
        path: ':scenarioId',
        props: true,
        children: [
          {
            path: '',
            name: 'ScenarioOverview',
            component: () => import('@/modules/msel-doctor/views/ScenarioOverview.vue'),
            props: true,
          },
          {
            path: 'timeline',
            component: () => import('@/modules/msel-doctor/views/TimelineView.vue'),
            props: true,
            children: [
              {
                path: '',
                name: 'TimelineThreads',
                component: () => import('@/modules/msel-doctor/views/TimelineView.vue'),
                props: true,
              },
              {
                path: 'threads',
                redirect: { name: 'TimelineThreads' },
              },
              {
                path: 'chronological',
                name: 'TimelineChronological',
                component: () => import('@/modules/msel-doctor/views/TimelineView.vue'),
                props: true,
              },
              {
                path: 'gantt',
                name: 'TimelineGantt',
                component: () => import('@/modules/msel-doctor/views/TimelineView.vue'),
                props: true,
              },
              {
                path: 'workinggroups',
                name: 'TimelineWorkingGroups',
                component: () => import('@/modules/msel-doctor/views/TimelineView.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'presentation',
            name: 'Presentation',
            component: () => import('@/modules/msel-doctor/views/PresentationView.vue'),
            props: true,
          },
        ],
      },
    ],
  },
]
